module.exports = __webpack_public_path__ + "static/img/28.9340a33a.png";